/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspaidsoon2Inputs */

const en_ticketspaidsoon2 = /** @type {(inputs: Ticketspaidsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selling paid tickets here is coming soon. Free tickets and paying at the door already work.`)
};

const de_ticketspaidsoon2 = /** @type {(inputs: Ticketspaidsoon2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezahlte Tickets kannst du hier bald verkaufen. Kostenlose Tickets und Zahlung vor Ort gehen schon.`)
};

/**
* | output |
* | --- |
* | "Selling paid tickets here is coming soon. Free tickets and paying at the door already work." |
*
* @param {Ticketspaidsoon2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspaidsoon2 = /** @type {((inputs?: Ticketspaidsoon2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspaidsoon2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspaidsoon2(inputs)
	return de_ticketspaidsoon2(inputs)
});
export { ticketspaidsoon2 as "ticketsPaidSoon" }